<template>
  <div class="pt-100">
    <equipe />
  </div>
</template>

<script>
import equipe from "@/views/myComponent/equipe";

export default {
  name: "team",
  components: {
    equipe,
  },
  data: function() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
